export enum Salutation {
  NoSalutation = 'Keine Angabe',
}

export interface Newsletter {
  id: number;
  name: string;
  description: string;
  link?: string;
}

export interface NewsletterLatest {
  mailingId: number;
  title: string;
  date: string;
  description: string;
}

export interface ProfileData {
  newsletters?: Newsletter[];
  email?: string;
  salutation?: string;
  lastname?: string;
  firstname?: string;
  bksakTheaterfunken?: boolean;
  bksakZielgruppe?: string;
}

export interface UnsubscribeFeedbackData {
  reason: string;
  commentary?: string;
  email: string;
  friendlyCaptcha?: string;
}

export interface MailingContent {
  html: string;
}
